import { enforce, test } from "vest";
import { accessFormFieldValue, createFieldName } from "@/forms/form-field";
import { trans } from "@/service/i18n/i18n";

export function createSelectFieldValidationSuite(
  definition: SelectField,
  formValue: any,
): void {
  const value = accessFormFieldValue(definition, formValue) as {
    value: string;
    label: string;
  };

  if (definition.required) {
    test(createFieldName(definition), trans("form_validation.required"), () => {
      enforce(value).isNotNull();
    });
  }
}
